import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fc52d74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "interfaces" }
const _hoisted_2 = ["onClick", "theme"]
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "base-line" }
const _hoisted_5 = { class: "content pa-20" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "interface__wrapper-title mt-40" }, "Мемасик", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "interface__wrapper-description" }, "Легкий и позитивный веб-сериал о жизни 13-летнего Мирона и его отношениях с мамой.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "interface__wrapper-category uppercase" }, "Сериал 8 серий реалити 8+", -1))

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import BaseHeaderDemo from '@/components/Headers/BaseHeaderDemo.vue'
import BaseLine from '@/components/Lines/BaseLine.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import { ref } from 'vue'
import { useUserStore } from '@/stores/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'InterfaceSlider',
  setup(__props) {

const userStore = useUserStore()

const themes = ['b', 'w', 'r', 'g']
const selectedTheme = ref('b')
const changeTheme = async (id: string) => {
  const container = document.getElementById('app')
  if (container) {
    container.setAttribute('theme', id)
    await userStore.setTheme(id)
    selectedTheme.value = id
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      "slides-per-view": 'auto',
      "space-between": 20,
      class: "slider"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(themes, (theme) => {
          return _createVNode(_unref(SwiperSlide), {
            key: theme,
            class: "interface"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                onClick: ($event: any) => (changeTheme(theme)),
                class: "interface__wrapper",
                theme: theme
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(BaseHeaderDemo)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(BaseLine, { text: "твое личное время" })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(BaseButton, {
                    class: "uppercase",
                    bg: "theme",
                    border: "none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ПРЕМЬЕРА")
                    ]),
                    _: 1
                  }),
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8
                ])
              ], 8, _hoisted_2)
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _: 1
    })
  ]))
}
}

})